module.exports = __webpack_public_path__ + "f38dbe68c51e82940440c6d8735adeba.pdf";